export type BorderWidthToken = 'default' | 'thick';

export const border: Record<BorderWidthToken, number> = {
  default: 1, // 1px
  thick: 2, // 2px
};
